import React, { useEffect } from 'react';
import { Controller } from 'react-hook-form';
import { createSelector } from '@reduxjs/toolkit';

import type { ISelectInputCountry } from './types';

import { useAppDispatch, useAppSelector } from '@/hooks';
import { getCountriesList } from '@/store/slices/utilsSlice';
import { Select } from '@/components/common/form';
import { selectCountriesList } from '@/store/selectors/utilsSelectors';

const selectInputCountrySelector = createSelector(selectCountriesList, countriesList => ({ countriesList }));

const SelectInputCountry = (props: ISelectInputCountry): React.ReactElement => {
  const dispatch = useAppDispatch();
  const { countriesList } = useAppSelector(selectInputCountrySelector);

  const { defaultValue, onChange, control, ...rest } = props;

  useEffect(() => {
    dispatch(getCountriesList());
  }, []);

  const options = countriesList.map(country => ({
    value: country.id,
    label: country.countryname,
  }));

  const handleOnChange = onChange;

  return (
    <Controller
      name={rest.name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { value, onChange } }) => (
        <Select
          options={options}
          onChange={event => {
            onChange(event);
            handleOnChange && handleOnChange(event);
          }}
          value={value}
          {...rest}
        />
      )}
    />
  );
};

export { SelectInputCountry };
